(function () {
  if (customElements.get('popup-welcome')) return;

  class PopupWelcome extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'popup-welcome-shown-' + (this.dataset.sectionId || 'default');
      this.delay = (parseFloat(this.dataset.delay) || 0) * 1000;
      this.frequencyDays = parseFloat(this.dataset.frequencyDays || '0');

      this.closeButtons = this.querySelectorAll('[data-popup-close]');
      this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });

      const copyBtn = this.querySelector('.popup-welcome__copy');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          const code = this.dataset.discountCode || '';
          if (navigator.clipboard && code) {
            navigator.clipboard.writeText(code).then(() => {
              copyBtn.classList.add('is-copied');
              copyBtn.textContent = copyBtn.dataset.copiedLabel || copyBtn.textContent;
            });
          }
        });
      }

      // Design mode: the theme editor toggles the section; show immediately when selected.
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this)) this.open(true);
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target.contains(this)) this.close(true);
        });
        return;
      }

      if (this.wasShownRecently()) return;
      this.timer = setTimeout(() => this.open(), this.delay);
    }

    disconnectedCallback() {
      if (this.timer) clearTimeout(this.timer);
    }

    wasShownRecently() {
      if (this.frequencyDays <= 0) return false;
      try {
        const ts = localStorage.getItem(this.storageKey);
        if (!ts) return false;
        return Date.now() - parseInt(ts, 10) < this.frequencyDays * 86400000;
      } catch (e) {
        return false;
      }
    }

    open(skipStorage) {
      this.classList.add('is-open');
      this.previouslyFocused = document.activeElement;
      const dialog = this.querySelector('.popup-welcome__dialog');
      if (dialog) {
        dialog.setAttribute('tabindex', '-1');
        dialog.focus({ preventScroll: true });
      }
      if (!skipStorage) {
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (e) { /* storage unavailable */ }
      }
    }

    close(silent) {
      this.classList.remove('is-open');
      if (!silent && this.previouslyFocused && this.previouslyFocused.focus) {
        this.previouslyFocused.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('popup-welcome', PopupWelcome);
})();
